'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enhancer = function enhancer(Component) {
  var EmptyItemState = function (_React$Component) {
    _inherits(EmptyItemState, _React$Component);

    function EmptyItemState(props, context) {
      _classCallCheck(this, EmptyItemState);

      var _this = _possibleConstructorReturn(this, (EmptyItemState.__proto__ || Object.getPrototypeOf(EmptyItemState)).call(this, props, context));

      _this.emptyItem = null;
      _this.isExecuting = false;

      _this.tryAppendEmptyItem = _this.tryAppendEmptyItem.bind(_this);
      _this.tryRemoveEmptyItem = _this.tryRemoveEmptyItem.bind(_this);
      _this.isLastEmpty = _this.isLastEmpty.bind(_this);
      return _this;
    }

    _createClass(EmptyItemState, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        this.tryAppendEmptyItem();
        this.context.emitter.addListener('cleanEditing', this.tryRemoveEmptyItem);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate() {
        this.tryAppendEmptyItem();
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context.emitter.removeListener('cleanEditing', this.tryRemoveEmptyItem);
      }
    }, {
      key: 'tryAppendEmptyItem',
      value: function () {
        var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee() {
          var _props, isFull, stopAppend, _props2, createEmpty, onChange, item;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _props = this.props, isFull = _props.isFull, stopAppend = _props.stopAppend;

                  // use tab to focus next input with autofill
                  // will trigger `componentDidUpdate` twice in short time
                  // so using `isExecuting` to prevent append more than one empty item

                  if (!(!this.isExecuting && !this.isLastEmpty() && !isFull && !stopAppend)) {
                    _context.next = 19;
                    break;
                  }

                  _context.prev = 2;

                  this.isExecuting = true;

                  _props2 = this.props, createEmpty = _props2.createEmpty, onChange = _props2.onChange;
                  _context.next = 7;
                  return createEmpty();

                case 7:
                  item = _context.sent;


                  this.emptyItem = item;
                  onChange(function (value) {
                    return [].concat(_toConsumableArray(value), [item]);
                  });
                  _context.next = 16;
                  break;

                case 12:
                  _context.prev = 12;
                  _context.t0 = _context['catch'](2);

                  // eslint-disable-next-line no-alert
                  window.alert('Error: appendEmptyItem', _context.t0);
                  throw _context.t0;

                case 16:
                  _context.prev = 16;

                  this.isExecuting = false;
                  return _context.finish(16);

                case 19:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, this, [[2, 12, 16, 19]]);
        }));

        function tryAppendEmptyItem() {
          return _ref.apply(this, arguments);
        }

        return tryAppendEmptyItem;
      }()
    }, {
      key: 'removeLastItem',
      value: function removeLastItem(props) {
        var onChange = props.onChange;

        return new Promise(function (resolve) {
          return onChange(function (v) {
            return v.slice(0, -1);
          }, resolve);
        });
      }
    }, {
      key: 'tryRemoveEmptyItem',
      value: function tryRemoveEmptyItem() {
        // ISSUE empty item 裡的 input 可能也會在 `endEditing` 修改 empty item
        // 可能要分成 `endEditing` 與 `clearInvalid`
        if (!this.isLastEmpty()) return true;
        return this.removeLastItem(this.props);
      }
    }, {
      key: 'isLastEmpty',
      value: function isLastEmpty() {
        var value = this.props.value;

        var last = value[value.length - 1];
        return this.emptyItem === last;
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { isLastEmpty: this.isLastEmpty(), removeLastItem: this.removeLastItem }));
      }
    }]);

    return EmptyItemState;
  }(_react2.default.Component);

  EmptyItemState.propTypes = {
    value: _propTypes.array,
    onChange: _propTypes.func.isRequired,
    createEmpty: _propTypes.func.isRequired,
    isFull: _propTypes.bool,
    stopAppend: _propTypes.bool
  };

  EmptyItemState.contextTypes = {
    emitter: _propTypes.object
  };

  return EmptyItemState;
};

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'appendEmptyItem');


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocEditor/editLineItems/appendEmptyItem.js
// module id = 1835
// module chunks = 0